import { USER_STAFF_MEMBER_BUILDINGS_ENTITY } from '../../../constants/entity'
import {
  BUILDING_FORM_FIELD_NAME_RESPONSIBLE_MANAGER,
  BUILDING_FORM_INITIAL_VALUES,
} from '../../Building'
import { EntityTabBuildings } from '../../EntityTab'
import { toUserSelectItem } from '../../User'

import {
  USER_PROFILE_TAB_BUILDINGS_QA_NAME,
  USER_PROFILE_TAB_BUILDINGS_SCOPE_FILTER_KEY,
} from './UserProfileTabBuildings.constants'

function UserProfileTabBuildings({ userData, onReloadTabCounters }) {
  const creationInitialValues = {
    ...BUILDING_FORM_INITIAL_VALUES,
    [BUILDING_FORM_FIELD_NAME_RESPONSIBLE_MANAGER]: [
      toUserSelectItem(userData),
    ],
  }

  return (
    <EntityTabBuildings
      creationInitialValues={creationInitialValues}
      entity={USER_STAFF_MEMBER_BUILDINGS_ENTITY}
      qaName={USER_PROFILE_TAB_BUILDINGS_QA_NAME}
      scopeFilterKey={USER_PROFILE_TAB_BUILDINGS_SCOPE_FILTER_KEY}
      scopeId={userData?.id}
      onReloadCounters={onReloadTabCounters}
    />
  )
}

export default UserProfileTabBuildings
